/**
 * video要素をスクロールで自動再生する、スマホはgifアニメ（画像）
 */

import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';

export default class ScrollPlayVideo2 {
  /**
   * コンストラクタ
   */
  constructor(parent) {
    // PCの場合はスクロールでvideo再生
    // スマホの場合はvideoを削除して、imgを表示
    this.isPC = Useragnt.pc;
    this.name = 'ScrollPlayVideo2'; // クラス名

    if (parent) {
      this.parent = document.querySelectorAll(parent);
    } else {
      this.parent = document;
    }

    this.childSelector = '.scroll-play2';
    this.videos = [];

    if (this.isPC) {
      this.initPC();
    } else {
      this.initSP();
    }
  }

  /**
   * PC用初期化
   */
  initPC() {
    this.parent.forEach((el, x) => {
      el.querySelectorAll(this.childSelector).forEach((block, y) => {
        // サイズ計算
        const videoRatio = this.getBlockSize(block.getAttribute('data-ratio'));
        const colVideo = block.querySelector('.col-video');

        // video設定
        const video = block.querySelector('video');
        video.controls = false;
        video.playsinline = true;
        video.loop = true;
        video.muted = true;

        this.videos.push({
          el: video,
          isPlaying: false
        });

        // img要素削除
        const i = colVideo.querySelector('img');
        i.parentNode.removeChild(i);

        // サイズ固定用ブロック
        if (videoRatio) {
          TweenMax.set(colVideo, {className: '+=is-before-none'});
          colVideo.appendChild(this.createBlockSize(videoRatio));
        }
      });
    });

    // イベント設定
    ResizeWatch.registerObserver(this.name, this);
    ScrollWatch.registerObserver(this.name, this);
  }

  /**
   * SP用初期化
   */
  initSP() {
    this.parent.forEach((el, x) => {
      el.querySelectorAll(this.childSelector).forEach((block, y) => {
        // サイズ計算
        const videoRatio = this.getBlockSize(block.getAttribute('data-ratio'));
        const colVideo = block.querySelector('.col-video');

        // 画像セットする
        const img = block.querySelector('img');
        const src = img.getAttribute('data-src');
        //img.setAttribute('src', src);
        img.style.visibility = 'visible';

        // video要素削除
        const v = colVideo.querySelector('video');
        v.parentNode.removeChild(v);

        // サイズ固定用ブロック
        if (videoRatio) {
          TweenMax.set(colVideo, {className: '+=is-before-none'});
          colVideo.appendChild(this.createBlockSize(videoRatio));
        }
      });
    });
  }

  /**
   * 縦横サイズを取得してサイズ（padding-topの%）を計算
   */
  getBlockSize(dataRatio) {
    if (!dataRatio) {
      return null;
    }

    let ratio = dataRatio;
    let videoRatio = null;
    if (ratio) {
      ratio = ratio.split(',');
      videoRatio = (parseInt(ratio[1], 10) / parseInt(ratio[0], 10)) * 100;
    }

    return videoRatio;
  }

  /**
   * 隠しspanを生成する
   */
  createBlockSize(videoRatio) {
    const span = document.createElement("span");
    span.style.display = 'block';
    span.style.width = '100%';
    if (videoRatio > 0) span.style.paddingTop = `${videoRatio}%`;

    return span;
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    // スクロール再処理
    this.scrollUpdate(ScrollWatch._currentScrollY());
  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    const winBottom = _scrollY + window.innerHeight;
    //const winBottomDeep = _scrollY + (window.innerHeight * 1.5);

    for (let i = 0; i < this.videos.length; i++) {
      const ref = this.videos[i];
      const posY = AnyStore.getOffsetTop(ref.el).top;

      if (posY < winBottom && _scrollY < posY + ref.el.clientHeight) {
        if (ref.isPlay) continue;
        // 再生
        ref.isPlay = true;
        ref.el.play();
      } else {
        if (!ref.isPlay) continue;
        // 停止
        ref.isPlay = false;
        ref.el.pause();
      }
    }
  }
}